import { render, staticRenderFns } from "./SelectSupplierComodity.vue?vue&type=template&id=5c013dac&"
import script from "./SelectSupplierComodity.vue?vue&type=script&lang=js&"
export * from "./SelectSupplierComodity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports